import { render, staticRenderFns } from "./healthyList.vue?vue&type=template&id=a4d64464&scoped=true"
import script from "./healthyList.vue?vue&type=script&lang=js"
export * from "./healthyList.vue?vue&type=script&lang=js"
import style0 from "./healthyList.vue?vue&type=style&index=0&id=a4d64464&prod&lang=scss&scoped=true"
import style1 from "./healthyList.vue?vue&type=style&index=1&id=a4d64464&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d64464",
  null
  
)

export default component.exports